"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBroadcastParams = require("./useBroadcastParams");
Object.keys(_useBroadcastParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBroadcastParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBroadcastParams[key];
    }
  });
});